import React from 'react';
import ReactDOM from 'react-dom';
import VmogApp from './VmogApp';
import './styles/styles.scss';

ReactDOM.render(<VmogApp />, document.getElementById('root'));
